import styled from 'styled-components'

const Top = styled.span`
  display: inline;
  visibility: hidden;
`

export { Top }
